import { render, staticRenderFns } from "./ribbon.vue?vue&type=template&id=06611f92&scoped=true"
import script from "./ribbon.vue?vue&type=script&lang=js"
export * from "./ribbon.vue?vue&type=script&lang=js"
import style0 from "./ribbon.vue?vue&type=style&index=0&id=06611f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06611f92",
  null
  
)

export default component.exports